import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    gray: {
      "50": "#F2F2F2",
      "100": "#66788A",
    },
    blue: {
      "200": "#278DCA",
    },
    black: {
      "700": "#212529",
    },
  },
  fonts: {
    heading: "Roboto",
    body: "Roboto",
  },
  styles: {
    global: {
      body: {
        bg: "gray.50",
        color: "black.700",
      },
    },
  },
});
